import React, { useEffect } from "react";
import TrainingModuleTable from "./components/TrainingModuleTable";
import { connect } from "react-redux";
import SummaryCard from "components/widget/SummaryCard";
import { Award, BookOpen, TrendingUp, Users } from "lucide-react";
import {
	getTeamModuleStat
} from "../../../redux/overview/overviewState";


const TrainingModules = ({
	getStats,
	recordStat
}) => {

	useEffect(() => {
		getStats();
	}, [getStats]);
	
	return (
		<div className="space-y-6">
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
				<SummaryCard
					title={"Total Modules"}
					icon={<BookOpen size={16}/>}
					displayCount={recordStat?.total_modules}
					description={"Available programs"}
					textColor="text-slate-900 dark:text-slate-50"
				/>	

				<SummaryCard
					title={"Total Enrollments"}
					icon={<Users size={16}/>}
					displayCount={recordStat?.total_enrollments}
					description={"Across all modules"}
					textColor="text-blue-600 dark:text-blue-500"
				/>

				<SummaryCard
					title={"Completed"}
					icon={<Award size={16}/>}
					displayCount={recordStat?.total_completed_modules}
					description={"Modules completed"}
					textColor="text-green-600 dark:text-green-500"
				/>		
				<SummaryCard
					title={"Avg. Completion"}
					icon={<TrendingUp size={16}/>}
					displayCount={`${recordStat?.average_completion}%`}
					description={"Success rate"}
					textColor="text-purple-600 dark:text-purple-500"
				/>	
			</div>
	      	<TrainingModuleTable />
	    </div>
    );
};

const mapStateToProps = (state) => ({
	recordStat: state.overview.teamModuleStat?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getStats: (data) => dispatch(getTeamModuleStat(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModules);